import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  card: {
    margin: 'auto',
    height: '100%'
  }
}))
